import { render, staticRenderFns } from "./CertificateViewModal.vue?vue&type=template&id=11b2dd8b"
import script from "./CertificateViewModal.vue?vue&type=script&lang=js"
export * from "./CertificateViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports